commonModule.factory('userAuthenticateService', ['$http', 'AppSettings', 'commonRESTCallService', '$window', '$q',
    function ($http, AppSettings, commonRESTCallService, $window, $q) {
        var userAPI = {};

        var userToken = '';
        var userId = ''; // The IM User ID

        var myMainURL = AppSettings.startIdentitySvcURL + 'userauthentications/';
        var myTokenURL = AppSettings.startIdentitySvcURL + 'tokens/claims?mins=' + AppSettings.userTokenTimeMinutes;

        var sessionTokenKey = AppSettings.SESSION_IM_TOKEN;

        userAPI.IsUserAuthenticated = function () {
            return commonRESTCallService.getFromServerWithToken(myTokenURL, $window.sessionStorage.getItem(sessionTokenKey));
        };

        userAPI.GetRenewedToken = function () {
            var deferred = $q.defer();

            commonRESTCallService.getFromServerWithToken(myTokenURL, userAPI.getUserToken())
            .success(function (response, status, headers) {
                var renewedTok = response.RenewedToken;
                deferred.resolve(renewedTok);
            })
            .error(function (response, status, headers, config) {
                deferred.reject(response);
            });

            return deferred.promise;
        };

        userAPI.GetClaimInfo = function () {
            var deferred = $q.defer();

            commonRESTCallService.getFromServerWithToken(myTokenURL, userAPI.getUserToken())
            .success(function (response, status, headers) {
                deferred.resolve(response);
            })
            .error(function (response, status, headers, config) {
                deferred.reject(response);
            });

            return deferred.promise;
        };

        userAPI.getUserToken = function () {
            userToken = $window.sessionStorage.getItem(sessionTokenKey);
            return userToken;
        };

        userAPI.setUserToken = function (token) {
            userToken = token;
            $window.sessionStorage.setItem(sessionTokenKey, token);
        };

        userAPI.getUserId = function () {
            return userId;
        };

        userAPI.setUserId = function(id) {
            userId = id;
        };

        userAPI.clearUserToken = function () {
            userToken = '';
            userId = '';
        };

        //get credential
        userAPI.getCredentialTemplate = function () {
            return commonRESTCallService.getFromServer(myMainURL + '?act=template');
        };

        //save a provider
        userAPI.authenticateCredentials = function (creds) {
            return commonRESTCallService.postToServer(myMainURL, creds);
        };

        userAPI.resetPassword = function(resetParameters) {
            var url = myMainURL + "passwordreset/";
            return commonRESTCallService.postToServer(url, resetParameters);
        };

        return userAPI;
    }
]);
